import { FunctionComponent, useState } from "react";

import { DefaultButton, Dialog } from "@bps/fluent-ui";
import { EnableUserForm } from "@libs/api/gateways/bp-id/EnableUserForm";
import { PltUser } from "@libs/api/gateways/plt/plt-gateway.dtos";

interface EnableOrDisableUserButtonProps {
  user: PltUser;
  accountEnabled: boolean;
}

export const EnableOrDisableUserButton: FunctionComponent<EnableOrDisableUserButtonProps> = ({
  user,
  accountEnabled
}) => {
  const [showEnabledDialog, setShowEnabledDialog] = useState<boolean>(false);

  return (
    <>
      {" "}
      {showEnabledDialog && (
        <Dialog hidden={false}>
          <EnableUserForm
            user={user}
            enable={!accountEnabled}
            onSubmit={() => setShowEnabledDialog(false)}
          />
        </Dialog>
      )}
      {accountEnabled ? (
        <DefaultButton
          onClick={() => {
            setShowEnabledDialog(true);
          }}
        >
          Disable User
        </DefaultButton>
      ) : (
        <DefaultButton
          onClick={() => {
            setShowEnabledDialog(true);
          }}
        >
          {" "}
          Enable User
        </DefaultButton>
      )}{" "}
    </>
  );
};
